import escapeRegExp from "lodash/escapeRegExp";
import type { FormatOptionLabelMeta } from "react-select";
import type { DataListOptions } from "~/services/dataListOptions/getDataListOptions";

function splitHighlightWord(
  text: string | undefined,
  matchWord: string,
): string[] {
  if (!text) return [];
  return text.split(new RegExp(`(${escapeRegExp(matchWord)})`, "gi"));
}

const renderHighlightText = (
  wordParts: string[],
  matchWord: string,
  testId: string,
) => {
  return wordParts.map((wordPart, index) =>
    wordPart.toLowerCase() === matchWord.toLowerCase() ? (
      // oxlint-disable-next-line react/no-array-index-key
      <strong data-testid={testId} key={`${wordPart}-${index}`}>
        {wordPart}
      </strong>
    ) : (
      wordPart
    ),
  );
};

const AutoSuggestFormatOptionLabel = (
  { label, subDescription }: DataListOptions,
  { context, inputValue }: FormatOptionLabelMeta<DataListOptions>,
) => {
  if (context === "value") {
    return <span className="focus:text-blue-100">{label}</span>;
  }

  const inputWithoutSpace = inputValue.trim();

  const labelParts = splitHighlightWord(label, inputWithoutSpace);
  const subDescriptionParts = splitHighlightWord(
    subDescription,
    inputWithoutSpace,
  );

  return (
    <div
      data-testid="auto-suggest-input-menu-item"
      className="kern-body"
      style={{ flex: "10" }}
    >
      {renderHighlightText(
        labelParts,
        inputWithoutSpace,
        "suggestion-item-label-highlight",
      )}
      <div className="primary">
        {renderHighlightText(
          subDescriptionParts,
          inputWithoutSpace,
          "suggestion-item-subDescription-highlight",
        )}
      </div>
    </div>
  );
};

export default AutoSuggestFormatOptionLabel;
